<template>
    <fieldset>
        <!-- Address Fields -->
        <h3 class="form-heading"><span v-if="label">{{ trans(label) }} </span>{{ trans('address') }}</h3>
        <div class="form-body">
            <txt label="address1" name="address1" v-model="model.address1"></txt>
            <txt label="address2" name="address2" v-model="model.address2"></txt>
            <txt label="city" name="city" v-model="model.city"></txt>
            <div class="split-fields">
                <txt label="state" name="state" v-model="model.state"></txt>
                <txt label="postal_code" name="postal_code" v-model="model.postal_code"></txt>
            </div>
            <country v-model="model.country_code"></country>
        </div><!-- .form-body -->
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default : '' },
            label: { default : false }
        },
        components: {
            'country': require('../components/form/country.vue').default
        },
        data: function() {
            return {
                model: {
                    address_id: 0,
                    address1: '',
                    address2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country_code: 'AU',
                }
            }
        },
        created() {
            this.$eventHub.$on('set' + this.name + 'Address', this.setAddress);
        },
        watch: {
            model: {
                handler: function (val, oldVal) {
                    this.$emit('input', this.model);
                },
                deep: true
            }
        },
        methods: {
            emit(){
                this.$emit('input', this.model);
            },
            setAddress(data) {
                this.model = this.$setData(data, this.model);
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('set' + this.name + 'Address', this.setAddress)
        }
    }
</script>
